var map = {
	"./bar-on.svg": "f734",
	"./bar.svg": "e1ae",
	"./custom-on.svg": "e0ff",
	"./custom.svg": "cbd5",
	"./none-on.svg": "51b6",
	"./none.svg": "e415",
	"./simple_logo-on.svg": "d873",
	"./simple_logo.svg": "62d0",
	"./watermark-on.svg": "c441",
	"./watermark.svg": "62d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e614";